var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('role-filter-pills',{attrs:{"value":_vm.value,"options":_vm.options,"disabled":_vm.disabled},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }